module.exports = "<div class=\"error ui-corner-all\" *ngIf=\"error\">\r\n    <div>\r\n        <span class=\"error-summary\">\r\n            <div class=\"ui-messages-error-icon\"></div>\r\n            <span class=\"error-refresh\">Error: {{ error }}</span>\r\n        </span>\r\n        <div class=\"close-button\" (click)=\"closeError()\">X</div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/error-handling/error.component.html
// module id = ./src/app/shared/error-handling/error.component.html
// module chunks = main